import { NavbarWrapper } from './wrapper';
import { Navbar } from './navbar';
import { NavbarMobileBottom } from './mobile-bottom';
import { DesktopSubMenu } from './desktop-submenu';
import { MobileSubMenu } from './mobile-submenu';
import type { NavbarServerProps } from './type';
import { useMemo } from 'react';
import { buildDropdownMenus } from './dropdown-menus';

export function NavbarServer({
  top,
  isMobile,
  initialTop,
  transitionToTop,
  isScrolled,
  isMenuOpen,
  openMenu,
  onToggleMenuOpen,
  onOpenDesktopMenu,
  hideBadge,
  showFreeCaseReviewButton = true,
  showTalkToSpecialistButton = true,
  claimSections,
  locations = [],
  bottom = -100,
  className,
  ctaHref,
  onClickCta,
  phone,
  navLinks,
  hideMobileBottomNav,
}: NavbarServerProps) {
  const menus = buildDropdownMenus(claimSections, locations);
  const desktopMenu = openMenu === 'locations' ? menus.locations : menus.claim;

  const initialState = !isScrolled && !isMenuOpen;

  const onlyNumberPhone = useMemo(() => {
    if (!phone) {
      return '';
    }
    const onlyNumber = phone?.replace(/[^\d]/g, '');
    return `tel:+1${onlyNumber}`;
  }, [phone]);

  return (
    <>
      <NavbarWrapper
        top={top}
        initialTop={initialTop}
        transitionToTop={transitionToTop}
        isMenuOpen={isMenuOpen}
        hideBadge={hideBadge}
        initialState={initialState}
        className={className}
      >
        <Navbar
          initialState={initialState}
          onToggleMenuOpen={onToggleMenuOpen}
          onOpenDesktopMenu={onOpenDesktopMenu}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          phone={onlyNumberPhone}
          showFreeCaseReviewButton={showFreeCaseReviewButton}
          showTalkToSpecialistButton={showTalkToSpecialistButton}
          navLinks={navLinks}
        />
        <DesktopSubMenu menu={desktopMenu} />
        <MobileSubMenu
          navLinks={navLinks}
          menus={menus}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          showFreeCaseReviewButton={showFreeCaseReviewButton}
        />
      </NavbarWrapper>
      {!hideMobileBottomNav && isMobile && (
        <NavbarMobileBottom
          bottom={bottom}
          phone={onlyNumberPhone}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          showFreeCaseReviewButton={showFreeCaseReviewButton}
          showTalkToSpecialistButton={showTalkToSpecialistButton}
        />
      )}
    </>
  );
}

export default NavbarServer;
